import {calculateDdiColorByRelevance} from "./utils";
import { useTranslation } from "react-i18next";
import {useContext, useState} from "react";
import InitContext from "../pages/InitContext";
import {Consts} from "../pages/consts";
import i18n from "i18next";
import {ddiRelevances, relevances} from "../../resources/json/jsons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const DdiElement = ({ ddi, productName }) => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);
  let apiText = ddiRelevances[ddi?.relevance?.apiText];
  const [isModalOpen, setModalOpen] = useState(false);
  let ddiCompound = ddi?.ddiDrug?.compound;
  ddiCompound = ddiCompound?.charAt(0)?.toUpperCase() + ddiCompound?.slice(1);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  if(apiText){
    apiText = apiText[i18n.language?.toUpperCase()];
  }

  let backgroundColorHcp = context?.role === Consts.PATIENT
    ? Consts.NONE
    : calculateDdiColorByRelevance(ddi?.relevance?.abdataCode);

  let  textColorHcp = context?.role === Consts.PATIENT
    ? "#1b7a9f"
    : backgroundColorHcp === Consts.RED || backgroundColorHcp === Consts.ORANGE
      ? Consts.WHITE
      : "#1b7a9f";

  return (
    <div className="w3-container w3-left-align w3-border w3-round-large w3-padding-small w3-margin">
      <div
        className="w3-row"
        style={{
          backgroundColor: backgroundColorHcp
        }}
      >
        <label style={{
          color: textColorHcp,
          paddingLeft: "10px",
        }}>
          <b>{ddiCompound}</b>{" "}
          {t("containing_in_your_medicine")}{" "}
          {productName}:
        </label>
      </div>
      <div
        className="w3-row"
        style={{
          backgroundColor: backgroundColorHcp
        }}
      >
        <div className="w3-col">
          <label style={{
            color: textColorHcp,
            paddingLeft: "10px",
          }}>
            <b>
              {t("relevance")}: {apiText}
            </b>
            <FontAwesomeIcon
              icon={ faInfoCircle }
              style={ {cursor: 'pointer', marginLeft: '8px'} }
              onClick={ toggleModal }
            />
            {isModalOpen && (
              <div className="modal">
                <div className="modal-content dialog-content-scroll">
                  <span className="close" onClick={toggleModal}>&times;</span>
                  <div>
                    <h3>{t("relevance")}</h3>
                  {<ul>
                    {Object.keys(relevances)?.map((key) => (
                      <li key={key} className="w3-margin-bottom">
                        <b>{ddiRelevances[key][i18n.language?.toUpperCase()]}</b>:
                        {relevances[key][i18n.language?.toUpperCase()]}
                      </li>
                    ))}
                  </ul>}
                  </div>
                </div>
              </div>
            )}
          </label>
        </div>
      </div>
    </div>
  );
};

export default DdiElement;
